import { jsx as _jsx } from "react/jsx-runtime";
import { __, _i } from "../utils/i18n.js";
import { rmlOpts } from "../utils/rmlOpts.js";
function applyTreeNodePermissionLock(node) {
    const { restrictions } = node.properties;
    if (restrictions?.length) {
        node.className["rml-locked"] = true;
    }
}
function applyUploadPermissionRules(preview, node, store) {
    const { properties } = node;
    if ((properties?.restrictions?.join() ?? "").indexOf("ins") > -1) {
        preview.node = store.getTreeItemById(+rmlOpts.others.rootId, false);
        preview.deny = _i(__("You cannot {{strong}}insert{{/strong}} new files. New files will be moved to Unorganized..."), {
            strong: /*#__PURE__*/ _jsx("strong", {})
        });
    }
}
export { applyTreeNodePermissionLock, applyUploadPermissionRules };
